<template>
  <div>
    <CCard>
      <CCardHeader>
        <slot name="header">
          <CIcon name="cil-grid" />
          {{ title }}
        </slot>
      </CCardHeader>
      <CCardBody>
        <Loading v-if="isLoading"></Loading>

        <div v-else>
          <CForm>
            <CRow>
              <CCol sm="6">
                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Produk Name"
                      invalid-feedback="Name should be filled"
                      required
                      v-model="$v.productForm.name.$model"
                      :is-valid="!$v.productForm.name.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>

                  <CCol sm="6">
                    <div class="product-group">
                      <label for="product_group">Product Group</label>
                      <model-select
                        class="form-control"
                        id="product_group"
                        :options="groupList"
                        v-model="$v.productForm.group.$model"
                        :isError="$v.productForm.group.$invalid"
                        @input="filterParentCategory"
                        :isDisabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.group.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Product Group should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <div class="parent-category">
                      <label for="parent_category">Category</label>
                      <model-select
                        class="form-control"
                        id="parent_category"
                        :options="parentCategory"
                        v-model="$v.productForm.parent_category.$model"
                        :isError="$v.productForm.parent_category.$invalid"
                        @input="filterCategory"
                        :isDisabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.parent_category.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Category should be filled.
                      </div>
                    </div>
                  </CCol>

                  <CCol sm="6">
                    <div class="sub-category">
                      <label for="sub_category">Sub Category</label>
                      <model-select
                        class="form-control"
                        id="sub_category"
                        :options="category"
                        v-model="$v.productForm.category.$model"
                        :isError="$v.productForm.category.$invalid"
                        :isDisabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.category.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Sub Category should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <div class="Agen">
                      <label for="agen">Seller</label>
                      <model-select
                        class="form-control"
                        id="agen"
                        :options="agentList"
                        v-model="$v.productForm.agent_code.$model"
                        :isError="$v.productForm.agent_code.$invalid"
                        :isDisabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.agent_code.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Seller should be filled.
                      </div>
                    </div>
                  </CCol>

                  <CCol sm="2">
                    <CInput
                      type="number"
                      label="Quantity"
                      min="0"
                      invalid-feedback="Quantity"
                      required
                      v-model="$v.productForm.quantity.$model"
                      :is-valid="!$v.productForm.quantity.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="4">
                    <div class="product_unit">
                      <label for="product_unit">Produk Unit</label>
                      <model-select
                        class="form-control"
                        id="product_unit"
                        :options="productUnitList"
                        v-model="$v.productForm.product_unit.$model"
                        :isError="$v.productForm.product_unit.$invalid"
                        :isDisabled="isReadonly"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.product_unit.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Product unit should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol sm="6">
                    <CInput
                      label="Brand"
                      invalid-feedback="Brand should be filled"
                      v-model="$v.productForm.brand.$model"
                      :is-valid="!$v.productForm.brand.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                  <CCol sm="6">
                    <CInput
                      label="Packaging Size"
                      invalid-feedback="Packaging Size should be filled"
                      v-model="$v.productForm.packaging_size.$model"
                      :is-valid="!$v.productForm.packaging_size.$invalid"
                      :readonly="isReadonly"
                    />
                  </CCol>
                </CRow>

                <CRow v-if="isAgentCanEdit">
                  <CCol sm="6">
                    <div class="status">
                      <label for="status">Status</label>
                      <model-select
                        class="form-control"
                        id="status"
                        :options="statusList"
                        v-model="$v.productForm.status.$model"
                        :isError="$v.productForm.status.$invalid"
                        placeholder="-- Harap pilih salah satu --"
                      ></model-select>
                      <div
                        v-if="$v.productForm.status.$invalid"
                        class="invalid-feedback-custom"
                      >
                        Status should be filled.
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="6">
                <CRow>
                  <CCol sm="12">
                    <CInput
                      label="Title"
                      invalid-feedback="Title should be filled"
                      
                      v-model="$v.productForm.title.$model"
                      placeholder="e.g Kalimat promosi untuk di share"
                      :is-valid="!$v.productForm.title.$invalid"
                      
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <label for="nik">Description</label>
                    <quill-editor
                      style="height: 150px; margin-bottom: 70px"
                      :content="content"
                      :options="editorOption"
                      v-model="$v.productForm.description.$model"
                      :disabled="isReadonly"
                      @change="onEditorChange($event)"
                    >
                    </quill-editor>
                    <div
                      v-if="$v.productForm.description.$invalid"
                      class="invalid-feedback-custom"
                    >
                      Description harus di isi.
                    </div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CForm>
        </div>
      </CCardBody>
      <CCardFooter align="right" :border-color="'white'">
        <CRow>
          <CCol sm="12">
            <CButton
              color="danger"
              title="Edit"
              size="sm"
              class="text-center"
              @click="back"
            >
              <i class="fa fa-undo"></i> Back </CButton
            >&nbsp;
            <CButton
              v-if="isAgentCanEdit"
              color="success"
              :disabled="$v.productForm.$invalid"
              title="Detail"
              size="sm"
              @click="save"
            >
              <i class="fa fa-edit" /> Save
            </CButton>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>

    <CCard>
      <CCardBody>
        <CTabs :active-tab.sync="activeTab">
           <CTab active>
            <template slot="title">Product Assets</template>
            <br />
            <Assets v-if="productForm.product_code" :products="productForm" :product-status="statusProduct"></Assets>
          </CTab>
          <!-- <CTab active>
            <template slot="title">Images</template>
            <UploadImage
              :products="productForm"
              :product-status="statusProduct"
            ></UploadImage>
          </CTab> -->
          <CTab>
            <template slot="title">Price</template>
            <br />
            <Price
              :products="productForm"
              :price="price"
              :product-status="statusProduct"
            ></Price>
          </CTab>
          <CTab>
            <template slot="title">Product Point</template>
            <br />
            <ProductPoint
              :products="productForm"
              :points="points"
              :product-status="statusProduct"
            ></ProductPoint>
          </CTab>
        </CTabs>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "../../../templates/Loading";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import UploadImage from "./tabs/UploadImage";
import Price from "./tabs/Price";
import ProductPoint from "./tabs/ProductPoint";
import Assets from "./tabs/Assets";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

export default {
  name: "ProductDetails",
  components: { GlobalTable, Loading, UploadImage, Price, ProductPoint, quillEditor, Assets },
  data() {
    return {
      title: "Product Detail",
      items: [],
      price: [],
      points: [],
      productForm: tableInterfaces.products,
      //parentCategoryList: [],
      //categoryList: [],
      groupList: [],
      agentList: [],
      statusList: [],
      productUnitList: [],
      tempParentCategoryList: [],
      tempCategoryList: [],
      isLoading: false,
      statusProduct: null,
      activeTab: 0,
      //enableAddPrice: true,
      content: "",
      editorOption: {}, // data quill
    };
  },
  validations: {
    productForm: {
      agent_code: { required },
      group: { required },
      parent_category: { required },
      category: { required },
      name: { required },
      title: {  },
      description: { required },
      status: { required },
      quantity: {},
      product_unit: { required },
      images: {},
      packaging_size: {},
      brand: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  computed: {
    isAgentCanEdit: function() {
      const admin_code = localStorage.getItem("admin_code");
      if(admin_code === 'undefined') {
        return true;
      } else {
        if(admin_code !== 'AD2006020001') {
          if(this.statusProduct !== '4') {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },
    isReadonly: function () {
      const agent = localStorage.getItem("is_agent");
      let ret = true;
      if(agent === "true") {
        if(this.statusProduct !== '7') {
          ret = true;
        } else {
          ret = false;
        }
      } else { 
        if(this.statusProduct === '1') {
          ret = true;
        } else {
          ret = false;
        }
      }
      return ret;
      //return this.statusProduct === "1" ? true : false;
    },
    parentCategory: function () {
      return this.tempParentCategoryList.filter(
        (x) => x.group === this.productForm.group
      );
    },
    category: function () {
      return this.tempCategoryList.filter(
        (x) => x.parent === this.productForm.parent_category
      );
    },
  },
  methods: {
    init: function (id) {
      this.getDropdown();
      this.getDetailProduct(id);
      this.getPrice(id);
      this.getPoints(id);
    },
    getPrice: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/product_price/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.price = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getPoints: function (id) {
      this.isLoading = true;
      this.axios
        .get("console/product_point/listing/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.points = response.data.data;
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.products) {
        tableInterfaces.products[i] = null;
      }
      this.productForm = tableInterfaces.products;
    },
    getDetailProduct: function (id) {
      this.isLoading = true;
      this.resetForm();
      this.axios
        .get("console/products/detail/" + id)
        .then((response) => {
          if (response.data.status === 2000) {
            this.productForm = response.data.data;
            this.statusProduct = this.productForm.status;
            this.getDropdownStatus(this.productForm.status);
            //this.setParentCategory();
            //this.setCategory();

            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getDropdown: function () {
      this.axios.get("/console/dropdown/products").then((response) => {
        this.groupList = response.data.group;
        this.tempCategoryList = response.data.category;
        this.tempParentCategoryList = response.data.parent_category;
        this.productUnitList = response.data.product_unit;
        this.agentList = response.data.agent;
        //this.statusList = response.data.product_status;
      });
    },
    getDropdownStatus: function(id) {
      this.axios.get("/console/dropdown/product-status/"+id).then((response) => {
        this.statusList = response.data.product_status;
      });
    },
    save: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        this.isLoading = true;
        this.axios
          .put("console/products/update", this.productForm)
          .then((response) => {
            this.showInfoNotification({
              title: "Ubah Product Issue",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Issue");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
      }
    },
    // setParentCategory: function () {
    //   this.parentCategoryList = this.tempParentCategoryList.filter(
    //     (x) => x.group === this.productForm.group
    //   );
    // },
    // setCategory: function () {
    //   this.categoryList = this.tempCategoryList.filter(
    //     (x) => x.parent === this.productForm.parent_category
    //   );
    // },
    filterParentCategory: function (event) {
      this.parentCategoryList = this.tempParentCategoryList.filter(
        (x) => x.group === this.productForm.group
      );
      this.productForm.category = null;
      this.productForm.parent_category = null;
    },
    filterCategory: function (event) {
      this.categoryList = this.tempCategoryList.filter(
        (x) => x.parent === this.productForm.parent_category
      );
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.productForm.description = html;
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
.ui.selection.dropdown.error {
  border-color: #e55353;
}
.ui.selection.dropdown {
  border-color: #2eb85c;
}
.ui.selection.dropdown.disabled {
  background-color: #d8dbe0;
  opacity: 0.8;
}
</style>
